import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loading, ErrorState } from "@/components/States";
import { ReportDialog } from "@/components/ReportDialog";

export default function LegalPage({ slug }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setDoc(null); setError(null);
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setError("Documento non disponibile."));
  }, [slug]);

  if (error) return <ErrorState message={error} />;
  if (!doc) return <Loading />;

  return (
    <article className="mx-auto max-w-3xl">
      <div className="flex items-start justify-between gap-4">
        <h1 className="font-display text-3xl font-bold text-[#F8FAFC] sm:text-4xl">{doc.title}</h1>
        {doc.status !== "approved" && (
          <span data-testid="legal-draft-badge" className="shrink-0 rounded-md border border-[#F59E0B]/40 bg-[#F59E0B]/10 px-2 py-1 text-xs font-semibold text-[#F59E0B]">Bozza · non approvata</span>
        )}
      </div>
      <div className="mt-6 whitespace-pre-wrap rounded-2xl border border-[#2A3655] bg-[#141B2D] p-6 leading-relaxed text-[#CBD5E1]" data-testid="legal-content">
        {doc.content}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <p className="text-xs text-[#64748B]">Versione {doc.version} · aggiornato {new Date(doc.updated_at).toLocaleDateString("it-IT")}</p>
        <ReportDialog targetType="public_content" targetId={`legal:${slug}`} label="Segnala un problema" />
      </div>
    </article>
  );
}
